export default __webpack_public_path__ + "6702ffc.png";